import {
  DefaultMessage,
  MessageSender,
  MessageType,
} from 'modules/mobiCopilot/utils/interfaces';

import * as DTO from './dto';

export const formatMessageSender = (values: DTO.MessageRole): MessageSender => {
  if (values === 'model') return 'server';
  if (values === 'user') return 'client';
  return 'server';
};

export const formatMessageType = (
  values: DTO.MessageContentType
): MessageType => {
  if (values === 'image/png') return 'image';
  if (values === 'text/markdown') return 'default';
  return 'default';
};

export const formatMessage = (
  values: DTO.GetMessageByIdR
): DefaultMessage[] => {
  const sender = formatMessageSender(values.role);
  const timestamp = new Date(values.createdat).getTime();

  const content = [...values.contents];

  return content.map(value => {
    const formatted: DefaultMessage = {
      id: value.id,
      content: '',
      sender,
      timestamp,
      type: formatMessageType(value.mimetype),
    };

    if (value.mimetype === 'text/markdown') {
      formatted.content = value?.data ?? '...';
    }

    if (value.mimetype === 'image/png') {
      formatted.content = value?.url ?? '';
    }

    return formatted;
  });
};
